import { api } from '@/shared/lib/axios.ts';
import type {
  DeployDraftRow,
  DeployDraftListResponse,
  DeployDraftListParams,
} from '@/shared/types/deploy.ts';

export interface ApproveDeployDraftDTO {
  titulo?: string;
  descricao?: string;
  iniciadoEm?: string;
  encerradoEm?: string;
  tenantIds?: string[];
}

export async function listDeployDrafts(
  params: DeployDraftListParams,
): Promise<DeployDraftListResponse> {
  const { data } = await api.get<DeployDraftListResponse>('/admin/deploy-drafts', { params });
  return data;
}

export async function getPendingDeployDraftsCount(): Promise<{ total: number }> {
  const { data } = await api.get<{ total: number }>('/admin/deploy-drafts/pending-count');
  return data;
}

export async function getDeployDraft(id: string): Promise<DeployDraftRow> {
  const { data } = await api.get<DeployDraftRow>(`/admin/deploy-drafts/${id}`);
  return data;
}

export async function approveDeployDraft(
  id: string,
  input: ApproveDeployDraftDTO,
): Promise<{ id: string; status: 'APROVADO'; maintenanceEventId: string }> {
  const { data } = await api.post(`/admin/deploy-drafts/${id}/approve`, input);
  return data;
}

export async function rejectDeployDraft(
  id: string,
  motivo: string,
): Promise<{ id: string; status: 'REJEITADO' }> {
  const { data } = await api.post(`/admin/deploy-drafts/${id}/reject`, { motivo });
  return data;
}
